module.exports = __webpack_public_path__ + "_/colorscheme/_grey_light.3PMG1YI.css";


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[sha512:hash:base64:7].css!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-colorsheme-res-resolver!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/stylus-loader!../colorscheme/_grey_light.styl
// module id = 1279
// module chunks = 4